import type { BettingType, EventStatus } from "@/hooks/firestore/betting/types";
import { isLiveViewOnly } from "@/utilities/sharedBettingUtilities";
import { useHasPermission } from "@/features/auth/hooks/usePermission";

export const useIsLiveViewOnly = (
  eventStatus?: EventStatus,
  bettingType?: BettingType,
) =>
  isLiveViewOnly(useHasPermission("viewLiveMarkets"), eventStatus, bettingType);
